import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { useMutation, useQueryClient } from "react-query";
import { FracaoCreateOrUpdateRequest } from "../typings";

function useCreateFracao() {
  const queryClient = useQueryClient();

  return useMutation(
    "create/v1/fracao/:id",
    ({ data }: { data: FracaoCreateOrUpdateRequest }) =>
      http.post('/v1/fracao', data),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries("/v1/fracao");
      },
      onError: (e) => {
        showErrorAxios(e)
      }
    }
  );
}

export default useCreateFracao;
